import { connectInstructions } from "../../util/redux";
import TimeInstructionsComponent from "../../components/time/instructions";

const TimeInstructions = connectInstructions(TimeInstructionsComponent);

export default TimeInstructions;
